import { render, staticRenderFns } from "./PaymentReceiptPreviewModal.vue?vue&type=template&id=1be452ca"
import script from "./PaymentReceiptPreviewModal.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentReceiptPreviewModal.vue?vue&type=style&index=0&id=1be452ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports